// extracted by mini-css-extract-plugin
module.exports = {"segment":"AppRouter_segment__3RuAQ"};